module.exports = __webpack_public_path__ + "img/img_isOpen_box.d833ca08.png";